<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputMonetary" });
import "tailwindcss/tailwind.css";
import { InputNumber } from "../index.js";
import { currency } from "../../common/format.js";
export let currencyCode = "EUR";
export let value;
export let name;
export let label = void 0;
export let placeholder = void 0;
export let hint = void 0;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = true;
export let minimum = 0;
export let maximum = void 0;
export let step = 0.01;
export let type = "number";
const format = (value2) => {
    if (value2 === void 0) {
        return "";
    }
    return currency(value2, currencyCode, false);
};
const getHint = (hint2, minimum2, maximum2) => {
    const HAS_MINIMUM = minimum2 !== void 0 && minimum2 !== 0;
    const HAS_MAXIMUM = maximum2 !== void 0;
    if (hint2 !== void 0) {
        return hint2;
    }
    if (HAS_MINIMUM && HAS_MAXIMUM) {
        return `between ${format(minimum2)} and ${format(maximum2)}`;
    }
    if (HAS_MINIMUM) {
        return `Minimum: ${format(minimum2)}`;
    }
    if (HAS_MAXIMUM) {
        return `Maximum: ${format(maximum2)}`;
    }
    return null;
};
$: defaultHint = getHint(hint, minimum, maximum);
</script>

<InputNumber
    bind:value
    hint = { defaultHint }
    { minimum }
    { maximum }
    { step }
    { label }
    { name }
    { isDisabled }
    { isReadonly }
    { isRequired }
    { placeholder }
    { type }
    mode = 'decimal'
    dimension = { currencyCode }
/>